import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectHasPolicy } from '../authentication/store/user.selector';
import { ControlDetails } from '../control/model/control.model';
import { refreshOrphanControl, startOrphanControl } from '../control/store/control.action';
import { selectAreOrphanControlsEnabled } from '../features/store/feature-flags.selector';
import { BatchControlEditDialogComponent } from '../building/batch-control-edit-dialog/batch-control-edit-dialog.component';
import { DialogService } from '../shared/service/dialog.service';
import { fetchAllRoles } from '../admin/store/admin.action';
import { CockpitService } from './cockpit.service';
import { UserWidgetComponent } from './user-widget/user-widget.component';
import { AccountManagementComponent } from './account-management/account-management.component';
import { MunicipalityWidgetComponent } from './municipality-widget/municipality-widget.component';
import { FeatureFlagsActivatorComponent } from './features-activator/feature-flags-activator.component';
import { TagsWidgetComponent } from './tags-widget/tags-widget.component';
import { MotdWidgetComponent } from './motd-widget/motd-widget.component';
import { OrphanControlsComponent } from './orphan-controls/orphan-controls.component';
import { ControlDashboardWidgetComponent } from './control-dashboard/control-dashboard-widget.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { OngoingBuildingControlsWidgetComponent } from './ongoing-building-controls-widget/ongoing-building-controls-widget.component';
import { NonCompliantDefectsWidgetComponent } from './non-compliant-defects-widget/non-compliant-defects-widget.component';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sibat-cockpit',
  template: `
    <ng-container>
      <div class="widget-container">
        <div class="widget-column">
          <sibat-user-widget></sibat-user-widget>
          @if (hasPolicyCockpitManagementGet$ | async) {
          <sibat-account-management-widget></sibat-account-management-widget>
          } @if (hasPolicyCockpitManagementGet$ | async) {
          <sibat-municipality-widget></sibat-municipality-widget>
          } @if (hasPolicyCockpitManagementGet$ | async) {
          <sibat-feature-flags-activator-widget></sibat-feature-flags-activator-widget>
          }
          <sibat-tags-widget></sibat-tags-widget>
        </div>
        <div class="widget-column">
          @if (hasPolicyCockpitManagementGet$ | async) {
          <sibat-motd-widget></sibat-motd-widget>
          } @if ((orphanControlsEnabled$ | async) && (hasPolicyCockpitNoBuildingControlWidgetGet$ | async)) {
          <sibat-orphan-controls
            (orphanControlStarted)="startOrphanControl()"
            (editOrphanControl)="editOrphanControl($event)"
          ></sibat-orphan-controls>
          } @if (hasPolicyControlWidgetGet$ | async) {
          <sibat-control-dashboard-widget></sibat-control-dashboard-widget>
          } @if (hasPolicyCockpitCheckListGet$ | async) {
          <sibat-checklist-dashboard></sibat-checklist-dashboard>
          }
        </div>
      </div>
      <div class="widget-row">
        @if (hasPolicyCockpitOngoingControlWidgetGet$ | async) {
        <sibat-ongoing-building-controls-widget data-testid="ongoing-controls"></sibat-ongoing-building-controls-widget>
        }
      </div>
      <div class="widget-row">
        @if (hasPolicyCockpitNoBuildingControlWidgetGet$ | async) {
        <sibat-non-compliant-defects-widget data-testid="defects"></sibat-non-compliant-defects-widget>
        } @if (hasPolicyCockpitManagementGet$ | async) {
        <div class="button-container">
          <button mat-flat-button color="primary" (click)="populateBuildingContextObjectTable('Bat', 'layer_context_1')">
            Remplir la table BuildingContextObject
          </button>
          <button mat-flat-button color="primary" (click)="populateCaseContextObjectTable('Aff', 'layer_context_1')">
            Remplir la table CaseContextObject
          </button>
        </div>
        }
      </div>
    </ng-container>
  `,
  styleUrls: ['cockpit.component.scss'],
  imports: [
    UserWidgetComponent,
    AccountManagementComponent,
    MunicipalityWidgetComponent,
    FeatureFlagsActivatorComponent,
    TagsWidgetComponent,
    MotdWidgetComponent,
    OrphanControlsComponent,
    ControlDashboardWidgetComponent,
    ChecklistComponent,
    OngoingBuildingControlsWidgetComponent,
    NonCompliantDefectsWidgetComponent,
    MatButton,
    AsyncPipe,
  ],
})
export class CockpitComponent implements OnInit {
  orphanControlsEnabled$ = this.store.select(selectAreOrphanControlsEnabled);
  hasPolicyCockpitManagementGet$ = this.store.select(selectHasPolicy('cockpit.management.get'));
  hasPolicyControlWidgetGet$ = this.store.select(selectHasPolicy('cockpit.controlWidget.get'));
  hasPolicyCockpitCheckListGet$ = this.store.select(selectHasPolicy('cockpit.checklist.get'));
  hasPolicyCockpitNoBuildingControlWidgetGet$ = this.store.select(selectHasPolicy('cockpit.noBuildingControlWidget.get'));
  hasPolicyCockpitOngoingControlWidgetGet$ = this.store.select(selectHasPolicy('cockpit.ongoingControlWidget.get'));

  constructor(private store: Store, private dialogService: DialogService, private cockpitService: CockpitService) {}

  ngOnInit(): void {
    this.store.dispatch(fetchAllRoles());
  }

  startOrphanControl() {
    this.store.dispatch(startOrphanControl());
    this.openControlModal();
  }

  editOrphanControl(controlId: number) {
    this.store.dispatch(refreshOrphanControl({ controlId }));
    this.openControlModal();
  }

  openControlModal() {
    this.dialogService.openDialogComponent<ControlDetails>(
      BatchControlEditDialogComponent,
      {
        count: 1,
      },
      'sibat-responsive-dialog'
    );
  }

  populateBuildingContextObjectTable(entity: string, context: string) {
    const requestObject = { entityType: entity, contextCode: context };
    this.cockpitService.sendObjectContext(requestObject).subscribe(
      response => {
        console.log('Server response:', response);
      },
      error => {
        console.error('Error while populating contexts:', error);
      }
    );
  }

  populateCaseContextObjectTable(entity: string, context: string) {
    const requestObject = { entityType: entity, contextCode: context };
    this.cockpitService.sendObjectContext(requestObject).subscribe(
      response => {
        console.log('Server response:', response);
      },
      error => {
        console.error('Error while populating contexts:', error);
      }
    );
  }
}
